import React from 'react';
import { X as CloseIcon, XCircle } from 'lucide-react';
import './Popup.css';

const ErrorPopup = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className={`popup-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="popup-close-btn">
          <CloseIcon size={24} />
        </button>
        <div className="popup-icon-wrapper error">
          <XCircle size={48} strokeWidth={2.5} />
        </div>
        <h2 className="popup-title">{title}</h2>
        <p className="popup-message">{message}</p>
        <div className="popup-actions">
          <button onClick={onClose} className="popup-button error">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;